/// <reference path="../../setup/_references.ts" />
module onvio.reports.firmManagementReports {
    'use strict';

    export class FirmManagementReporstListController {

        static $inject = [
            'onvio.reports.firmManagementReports.FirmManagementReportsListService'
        ];

        constructor(public reportsListService: onvio.reports.firmManagementReports.FirmManagementReportsListService) { }
    }
    angular.module('onvio.reports.firmManagementReports.FirmManagementReportsListController', ['onvio.reports.firmManagementReports.FirmManagementReportsListService'])
        .controller('onvio.reports.firmManagementReports.FirmManagementReportsListController', FirmManagementReporstListController);
}
